import { render, staticRenderFns } from "./conventionmodal.vue?vue&type=template&id=74b9f41b&scoped=true"
import script from "./conventionmodal.vue?vue&type=script&lang=js"
export * from "./conventionmodal.vue?vue&type=script&lang=js"
import style0 from "./conventionmodal.vue?vue&type=style&index=0&id=74b9f41b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9f41b",
  null
  
)

export default component.exports